import { motion } from 'framer-motion';
import { ReactNode } from 'react';

import './styles.scss';

const INITIAL_DELAY_SEC = 1;
const STEP_DELAY_SEC = 2;
const EXPAND_DURATION_SEC = 0.5;
const FADE_DURATION_SEC = 0.5;
const STEP_TOTAL_SEC = EXPAND_DURATION_SEC + FADE_DURATION_SEC;

interface AnimatedTextRevealProps {
  lines: ReactNode[];
}

const lineVariants = {
  hidden: { opacity: 0, height: 0 },
  visible: { opacity: 1, height: 'auto' },
};

const getLineTransition = (index: number) => {
  const baseDelay =
    INITIAL_DELAY_SEC + index * (STEP_DELAY_SEC + STEP_TOTAL_SEC);

  return {
    height: {
      duration: EXPAND_DURATION_SEC,
      delay: baseDelay,
      ease: 'easeInOut' as const,
    },
    opacity: {
      duration: FADE_DURATION_SEC,
      delay: baseDelay + EXPAND_DURATION_SEC,
      ease: 'easeInOut' as const,
    },
  };
};

const AnimatedTextReveal = ({ lines }: AnimatedTextRevealProps) => (
  <div className="animated-text-reveal">
    {lines.map((line, index) => (
      <motion.div
        key={index}
        className="animated-text-reveal__line"
        variants={lineVariants}
        initial="hidden"
        animate="visible"
        transition={getLineTransition(index)}
      >
        {line}
      </motion.div>
    ))}
  </div>
);

export type { AnimatedTextRevealProps };
export { AnimatedTextReveal };
